<template>
  <model-table
    :collection="item.itemVariations"
    :row-name="row => `${row.name} of ${row.parent.parent.name}`"
    :submodel="true"
    :orderable="true"
    :columns="[
      { field: 'id', component: 'id' },
      { field: 'name' },
      { field: 'price', component: 'money' },
      { field: 'cost', component: 'money' },
      { field: 'upcCode', label: 'UPC Code' },
      { field: 'salesDisabled', component: 'checkmark-or-negative', label: 'Disable Sales' },
      ...(currentSite.activeInventoryStrategy && item.isRemote ? [
        { name: 'hasRecipe', field: itemVariation => getTrackStock(itemVariation), component: 'checkmark-or-negative', label: 'Track Stock' }
      ] : []),
      { name: 'library', component: 'library-link', hide: currentCircuit.isLibrary, align: 'right' },
      { name: 'actions', align: 'right' }
    ]"
  >
    <item-variation-form />
  </model-table>
</template>

<script>

import Item from 'src/models/item/Item'
import ModelTable from 'src/modules/admin/components/ModelTable'
import ItemVariationForm from 'src/modules/admin/item/components/ItemVariationForm'

export default {
  name: 'ItemVariationTable',
  components: {
    ModelTable,
    ItemVariationForm
  },
  configuration: ['currentCircuit', 'currentSite', 'locations'],
  props: {
    item: {
      type: Item,
      required: true
    }
  },
  methods: {
    getTrackStock (itemVariation) {
      return itemVariation.hasRecipe || itemVariation.action === 'manage_inventory'
    }
  }
}
</script>
